/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const sharedMessages = defineMessages({
  copied: {
    id: 'channels.sharedMessages.copied',
    defaultMessage: 'Copied'
  },
  copyToClipboard: {
    id: 'channels.sharedMessages.copyToClipboard',
    defaultMessage: 'Copy to clipboard'
  },
  learnMore: {
    id: 'channels.sharedMessages.learnMore',
    defaultMessage: 'Learn more'
  },
  overlayCreateTitle: {
    id: 'channels.sharedMessages.overlayCreateTitle',
    defaultMessage: 'Create integration'
  },
  overlayEditTitle: {
    id: 'channels.sharedMessages.overlayEditTitle',
    defaultMessage: 'Edit integration'
  },
  saveAndExit: {
    id: 'channels.sharedMessages.saveAndExit',
    defaultMessage: 'Save and exit'
  },
  saved: {
    id: 'channels.sharedMessages.saved',
    defaultMessage: 'Saved'
  },
  close: {
    id: 'channels.sharedMessages.close',
    defaultMessage: 'Close'
  },
  next: {
    id: 'channels.sharedMessages.next',
    defaultMessage: 'Next'
  },
  back: {
    id: 'channels.sharedMessages.back',
    defaultMessage: 'Back'
  },
  finish: {
    id: 'channels.sharedMessages.finish',
    defaultMessage: 'Finish'
  },
  create: {
    id: 'channels.sharedMessages.create',
    defaultMessage: 'Create'
  },
  notSupported: {
    id: 'channels.sharedMessages.notSupported',
    defaultMessage: 'Channel {integrationName} not supported.'
  },
  open: {
    id: 'channels.sharedMessages.open',
    defaultMessage: 'Open'
  },
  tryEnterprise: {
    id: 'channels.sharedMessages.tryEnterprise',
    defaultMessage: 'Try Enterprise plan'
  },
  tryPlus: {
    id: 'channels.sharedMessages.tryPlus',
    defaultMessage: 'Try Plus plan'
  },
  add: {
    id: 'channels.sharedMessages.add',
    defaultMessage: 'Add'
  },
  delete: {
    id: 'channels.sharedMessages.delete',
    defaultMessage: 'Delete'
  },
  deleteFromAssistant: {
    id: 'channels.sharedMessages.deleteFromAssistant',
    defaultMessage: 'Delete from assistant'
  },
  removeFromAssistant: {
    id: 'channels.sharedMessages.removeFromAssistant',
    defaultMessage: 'Remove from assistant'
  },
  removeFromCatalog: {
    id: 'channels.sharedMessages.removeFromCatalog',
    defaultMessage: 'Remove from catalog'
  },
  cancel: {
    id: 'channels.sharedMessages.cancel',
    defaultMessage: 'Cancel'
  },
  none: {
    id: 'channels.sharedMessages.none',
    defaultMessage: 'None'
  },
  skillLimitMessage: {
    id: 'channels.sharedMessages.skillLimitMessage',
    defaultMessage:
      'You have reached the maximum number of skills. To create a new skill, delete an existing skill.'
  },
  // ChannelOverlay CancelConfirmationModal
  saveEditBody: {
    id: 'channels.overlay.saveEditBody',
    defaultMessage:
      'Would you like to save your edits to the integration before closing it?'
  },
  error403: {
    id: 'channels.sharedMessages.error403',
    defaultMessage: 'Request failed with status code 403'
  },
  invalidInput: {
    id: 'channels.sharedMessages.invalidInput',
    defaultMessage: 'Invalid'
  },
  hubSpotDescription: {
    id: 'channels.sharedMessages.hubSpotDescription',
    defaultMessage:
      'Ticket creation, feedback, submissions, and quotes, plus service and operations, made possible by the HubSpot API.'
  },
  appConnectDescription: {
    id: 'channels.sharedMessages.appConnectDescription',
    defaultMessage:
      'Enable a wide range of cloud services using the Integration Platform as a Service (iPaaS) product, IBM App Connect.'
  },
  coveoDescription: {
    id: 'channels.sharedMessages.coveoDescription',
    defaultMessage:
      'Create and manage source documents and perform search queries on an index with the Coveo Search API.'
  },
  googleCustomSearchDescription: {
    id: 'channels.sharedMessages.googleCustomSearchDescription',
    defaultMessage:
      'Search a website, a collection of websites, or the web using the Google Programmable Search Engine via Google Custom Search JSON API.'
  },
  IBMRPADescription: {
    id: 'channels.sharedMessages.IBMRPADescription',
    defaultMessage:
      'Add the IBM Robotic Process Automation (RPA) custom extension to automate business and IT processes at scale with ease and speed.'
  },
  magnoliaDescription: {
    id: 'channels.sharedMessages.magnoliaDescription',
    defaultMessage:
      'Access and search content by author on the open-source CMS via the Magnolia Delivery API.'
  },
  mailChimpCampaignManagementDescription: {
    id: 'channels.sharedMessages.mailChimpCampaignManagementDescription',
    defaultMessage:
      'Manage mailing lists and build newsletters and email marketing campaigns with Mailchimp.'
  },
  neuralSeekDescription: {
    id: 'channels.sharedMessages.neuralSeekDescription',
    defaultMessage:
      'Make AI feel more conversational by implementing the combined search and natural-language generation system of NeuralSeek from Cerebral Blue.'
  },
  serviceNowDescription: {
    id: 'channels.sharedMessages.serviceNowDescription',
    defaultMessage:
      'Automate business and IT digital workflows using the ServiceNow cloud-based platform.'
  },
  spotifyDescription: {
    id: 'channels.sharedMessages.spotifyDescription',
    defaultMessage:
      'Facilitate music and podcast streaming exploration, analysis, organization, and playback with Spotify.'
  },
  discoveryDescription: {
    id: 'channels.sharedMessages.discoveryDescription',
    defaultMessage:
      'Maximize the power of Watson by combining your assistant and the Discovery v2 search API.'
  },
  uploadAndReplace: {
    id: 'channels.sharedMessages.uploadAndReplace',
    defaultMessage: 'Upload and replace'
  },
  watsonxDescription: {
    id: 'channels.sharedMessages.watsonxDescription',
    defaultMessage:
      'Enterprise-ready AI and data platform designed to multiply the impact of AI across your business.'
  },
  zendeskGuideArticleSearchDescription: {
    id: 'channels.sharedMessages.zendeskGuideArticleSearchDescription',
    defaultMessage:
      'Find answers and info in the Zendesk Guide via the Zendesk Search Articles API.'
  },
  zendeskSupportDescription: {
    id: 'channels.sharedMessages.zendeskSupportDescription',
    defaultMessage:
      'Deliver effective customer service, manage tickets and teams, and monitor metrics with Zendesk.'
  }
});
